import { FETCH_IMAGE_ID } from "./ActionTypes";
import { FETCH_IMAGE_ID_LIST } from "./ActionTypes";

const initialState = {
  imageId: -1,
  imageIdList: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_IMAGE_ID:
      return {
        imageId: action.payload,
      };
    case FETCH_IMAGE_ID_LIST:
      return {
        ...state,
        imageIdList:
          action.payload === -1 ? [] : [...state.imageIdList, action.payload],
      };

    default:
      return state;
  }
};

export default reducer;
